export const messageDirectionEnum = Object.freeze({
    COMPANY_TO_CLIENT: 0,
    CLIENT_TO_COMPANY: 1
});